<template>
  <CategoryForm v-if="data" :formData="data" :func="funcType" :isUpdate="isUpdate" @submitData="submitData($event)" />
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import CategoryForm from '@/components/WelcomeSettings/CategoryForm'

export default {
  name: 'welcome-category-update',
  components: {CategoryForm},
  mixins: [Error],
  data () {
    return {
      data: null,
      funcType: '修改',
      isUpdate: true
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      api.detailData(this, api.getWelcomeCategoryUpdate(this.$route.params.categoryCode), 'category_info')
    },
    submitData (data) {
      api.updateData(this, api.getWelcomeCategoryUpdate(this.$route.params.categoryCode), data, this.updateCallback)
    },
    updateCallback () {
      this.$router.push({name: 'welcome-category-list', params: {save: true}})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CategoryUpdate.vue?8454ea0e